<template>
  <div class="grid-games">
    <v-sheet v-for="(skeleton ,i ) in count" :key="i">

      <v-skeleton-loader :class="`tw-opacity-[${(count/skeleton) * 20}%]`" height="186" max-width="300" type="card"></v-skeleton-loader>
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: ["count"],
};
</script>

<style scoped>
</style>